<template>
  <el-card class="ability-achieve">
    <template v-if="courseInfo?.capability_status === 0">
      <el-empty description="图谱尚未完成配置"></el-empty>
    </template>
    <template v-else>
      <h4>能力达成情况</h4>
      <el-row :gutter="15">
        <el-col :lg="9" :xl="10" v-if="showRadar">
          <div class="radar-chart" id="radar-chart"></div>
        </el-col>
        <el-col :lg="showRadar ? 7 : 16" :xl="showRadar ? 8 : 18">
          <el-table :data="radarTableData" header-row-class-name="header-transparent" class="table-ability">
            <el-table-column label="能力名称" prop="title"></el-table-column>
            <el-table-column prop="tier_avg" label="平均值" width="110"></el-table-column>
            <el-table-column prop="achieved" label="达成率" width="100"></el-table-column>
          </el-table>
        </el-col>
        <el-col :lg="8" :xl="6" style="text-align: right">
          <div class="update-card card-box flex-start flex-column">
            <div class="card-title">数据更新</div>
            <div v-if="isExpired" class="update-tips">当课程结束时间已过，课程不再更新</div>
            <div class="update-time-tip-box">
              <div class="last-update-time flex-start time-box">
                <div class="icon-box">
                  <i class="mdi mdi-clock-check-outline text-primary"></i>
                </div>
                <div class="time-text">
                  <span class="update-tips">最近一次更新：</span>
                  <span class="update-time" v-if="courseInfo.last_update_time">
                    {{ courseInfo.last_update_time?.replace(/-/g, '.') }}
                  </span>
                </div>
              </div>
              <div class="next-update-time flex-start time-box">
                <div class="icon-box">
                  <i class="mdi mdi-reload text-success"></i>
                </div>
                <div class="time-text">
                  <span class="update-tips">下一次更新：</span>
                  <span class="update-time">{{ nextUpdateTime }} 00:00:00</span>
                </div>
              </div>
            </div>

            <div class="btn-group flex-between">
              <el-button class="operate-btn" type="primary" :disabled="!updateUsable" @click="updateCourseStatsApi">
                更新统计
              </el-button>
              <el-button class="operate-btn" type="outline" @click="updateCourseTime"> 更改课程时间 </el-button>
              <div style="height: 40px"></div>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-table :data="tableData" class="table-1 mt-3">
        <el-table-column
          :prop="item.prop"
          :label="item.label"
          v-for="(item, index) in tableHeaderData"
          :key="index"
        ></el-table-column>
      </el-table>
      <div class="row my-3">
        <div class="col">
          <div class="flex-between flex-align-center">
            <div class="flex">
              <el-select
                class="target mr-2"
                v-model="indicatorName"
                placeholder="请选择指标"
                @change="getCourseCapabilityStatPagination"
              >
                <el-option value="0" label="全部指标"></el-option>
                <el-option
                  v-for="item in targetList"
                  :key="item.indicator_name"
                  :label="item.indicator_name"
                  :value="item.indicator_name"
                ></el-option>
              </el-select>
              <el-select
                class="students"
                v-model="student"
                placeholder="请选择全部学生"
                @change="getCourseCapabilityStatPagination"
              >
                <el-option value="0" label="全部学生"></el-option>
                <el-option
                  v-for="item in studentList"
                  :key="item.user_id"
                  :label="item.firstname"
                  :value="item.user_id"
                ></el-option>
              </el-select>
            </div>
            <div class="flex-right">
              <el-button type="primary" size="small" @click="exportTable">下载报表</el-button>
            </div>
          </div>
        </div>
      </div>
      <el-table :data="targetTableData">
        <el-table-column prop="firstname" label="学生名称">
          <template slot-scope="scope">
            <el-button type="text" @click="viewStudent(scope.row)">{{ scope.row.firstname }}</el-button>
          </template>
        </el-table-column>
        <el-table-column
          v-for="(item, index) in targetHeaderData"
          :key="index"
          :prop="String(item.sort)"
          :label="item.indicator_name"
        >
          <template slot-scope="scope">
            {{ getTargetValue(scope.row, item.sort) }}
          </template>
        </el-table-column>
      </el-table>
      <el-row v-if="this.totalSize > 0" class="flex-between flex-align-center mt-3">
        <el-col>
          <div>共{{ totalSize }}条数据</div>
        </el-col>
        <Pagination
          :perSize="pageSizesVal"
          :totalSize="totalSize"
          :currentPage="currentPage"
          @setPageSizesVal="getPageSizesVal"
          @setCurPageVal="getCurPageVal"
        ></Pagination>
      </el-row>
    </template>
  </el-card>
</template>
<script>
import { downloadFile } from '@/utils/commom.js'
import Pagination from '@/components/Pagination.vue'
import { domainName } from '@/config/setting.js'
export default {
  name: 'AbilityAchieve',
  components: { Pagination },
  data() {
    return {
      radarTableData: [],
      tableHeaderData: [],
      tableData: [],
      targetHeaderData: [],
      targetTableData: [],
      indicatorName: '0',
      targetList: [],
      student: '0',
      studentList: [],
      // 页码数据
      totalSize: 0,
      currentPage: 1,
      pageSizesVal: 10,
      indicatorGrade: {
        '-': 0,
        A: 100,
        B: 75,
        C: 50,
        D: 25,
      },
      updateUsable: true,
      isExpired: true,
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.commom.userInfo
    },
    courseInfo() {
      return this.$store.state.course.courseInfo
    },
    // 下一次更新统计时间
    nextUpdateTime() {
      let nextDayTime = new Date(Date.now() + 86400000)
      return `${nextDayTime.getFullYear()}.${
        nextDayTime.getMonth() + 1 < 10 ? '0' + (nextDayTime.getMonth() + 1) : nextDayTime.getMonth() + 1
      }.${nextDayTime.getDate()}`
    },
    showRadar() {
      return this.radarTableData.length > 3
    },
  },
  watch: {
    courseInfo: {
      handler(val) {
        if (val.capability_status > 0) {
          this.getCourseUpdateStatsApi()
          this.getCourseCapability()
        }
      },
    },
  },
  mounted() {
    console.log(this.$route)
    window.onresize = () => {
      this.platFormChart?.resize()
    }
  },
  methods: {
    getTargetValue(row, sort) {
      return row.list.find((item) => item.sort === sort)?.tier || '-'
    },
    // 获取课程能力达成
    async getCourseCapability() {
      await this.$store
        .dispatch('capability/getCourseCapability', {
          course_id: this.$route.query.courseId,
        })
        .then((res) => {
          console.log('getCourseCapability:', res)
          if (res.code === 1) {
            this.tableHeaderData = res.data?.list?.thead?.map((item, index) => {
              return {
                label: item,
                prop: String(index),
              }
            })
            this.tableData = res.data?.list?.tbody || []
            if (this.tableData.length > 0) {
              this.getCourseCapabilitySearchParam()
              let radarData = []
              let radarTableData = []
              res.data?.radar?.forEach((item) => {
                radarTableData.push({
                  title: item.title,
                  tier_avg: item.tier_avg,
                  achieved: item.achieved,
                })
                radarData.push({
                  name: item.title,
                  max: 100,
                })
              })
              this.radarTableData = radarTableData
              setTimeout(() => {
                this.iniRadarChart(res.data.radar)
              }, 200)
            }
          }
        })
        .catch((err) => {
          console.log('err:', err)
        })
    },
    // 更改课程时间
    updateCourseTime() {
      window.open(domainName + '/course/edit.php?id=' + this.$route.query.courseId, '_blank')
    },
    // 查询课程更新统计状态接口
    async getCourseUpdateStatsApi() {
      await this.$store
        .dispatch('course/getCourseUpdateStats', {
          course_id: Number(this.$route.query.courseId),
        })
        .then((res) => {
          console.log('1111res:', res.data.status)
          if (res.code === 1) {
            if (res.data.status == 0) {
              if (this.updateUsable) {
                this.updateUsable = false
              }
              if (!this.updateTimer) {
                this.updateTimer = setInterval(() => {
                  this.getCourseUpdateStatsApi()
                }, 1000)
              }
            } else if (res.data.status == 1) {
              this.updateUsable = true

              if (this.updateTimer) {
                clearInterval(this.updateTimer)
                this.$notify.success({
                  title: '更新统计已完成',
                  message: '即将在3秒后刷新页面',
                })
                setTimeout(() => {
                  window.location.reload()
                }, 3000)
              }
            } else if (res.data.status == 2) {
              this.updateUsable = true
              if (this.updateTimer) {
                clearInterval(this.updateTimer)
                this.$notify.warning({
                  title: '更新统计失败',
                })
              }
            }
          }
        })
        .catch((err) => {
          console.log('err:', err)
        })
    },
    // 点击执行更新统计接口
    async updateCourseStatsApi() {
      await this.$store
        .dispatch('course/updateCourseStats', {
          course_id: Number(this.$route.query.courseId),
        })
        .then((res) => {
          console.log('res:', res)
          if (res.code === 1) {
            this.$message.success('更新中，当更新完成后页面会自动刷新')
            this.getCourseUpdateStatsApi()
          }
        })
        .catch((err) => {
          console.log('err:', err)
        })
    },
    // 雷达图
    iniRadarChart(radarData) {
      if (!this.showRadar) return
      var chart = this.$echarts.init(document.getElementById('radar-chart'))
      var seriesData = radarData.map((item) => this.indicatorGrade[item.tier_avg])
      var option = {
        color: ['#409EFF'],
        legend: {
          show: true,
          data: ['平均能力评价'],
        },
        radar: {
          splitNumber: 4,
          radius: '70%',
          indicator: radarData.map((item) => {
            return {
              name: item.title,
              max: 100,
            }
          }),
        },
        series: [
          {
            name: '平均能力评价',
            type: 'radar',
            data: [
              {
                value: seriesData,
                name: '',
                areaStyle: {
                  color: new this.$echarts.graphic.RadialGradient(0.1, 0.6, 1, [
                    {
                      color: 'rgba(64, 158, 255, 0.5)',
                      offset: 0,
                    },
                    {
                      color: 'rgba(64, 158, 255, 0.1)',
                      offset: 1,
                    },
                  ]),
                },
              },
            ],
          },
        ],
      }
      chart.setOption(option)
      console.log('option', option)
      this.platFormChart = chart
    },
    // 课程全部学生达成情况筛选条件
    async getCourseCapabilitySearchParam() {
      await this.$store
        .dispatch('capability/getCourseCapabilitySearchParam', {
          course_id: this.$route.query.courseId,
        })
        .then((res) => {
          console.log('getCourseCapabilitySearchParam:', res)
          if (res.code === 1) {
            this.targetList = res.data?.list || []
            this.studentList = res.data?.userlist || []
            console.log('targetList', this.targetList)
          }
        })
        .catch((err) => {
          console.log('err:', err)
        }).finally(() => {
          this.getCourseCapabilityStatPagination()
        })
    },
    // 课程全部学生达成情况分页查询
    getCourseCapabilityStatPagination() {
      this.$store
        .dispatch('capability/getCourseCapabilityStatPagination', {
          course_id: this.$route.query.courseId,
          user_id: this.student === '0' ? '' : this.student,
          indicator_name: this.indicatorName === '0' ? '' : this.indicatorName,
          page: this.currentPage,
          pagesize: this.pageSizesVal,
        })
        .then((res) => {
          console.log('getCourseCapabilityStatPagination:', res)
          if (res.code === 1) {
            this.targetHeaderData =
              this.indicatorName === '0'
                ? [...this.targetList]
                : this.targetList.filter((item) => item.indicator_name === this.indicatorName)
            this.targetTableData = res.data.list || []
            this.totalSize = res.data.paging.records
          }
        })
        .catch((err) => {
          console.log('err:', err)
        })
    },
    exportTable() {
      this.$store
        .dispatch('capability/getCourseCapabilityStatPagination', {
          course_id: this.$route.query.courseId,
          user_id: this.student === '0' ? '' : this.student,
          indicator_name: this.indicatorName === '0' ? '' : this.indicatorName,
          print: 1,
        })
        .then((res) => {
          console.log('exportTable:', res)
          downloadFile(res, '学生能力达成情况')
        })
        .catch((err) => {
          console.log('err:', err)
        })
    },
    viewStudent(row) {
      window.open(
        `${domainName}/ability/#/ability-graph/detail/my-achieve?courseId=${this.$route.query.courseId}&userId=${row.user_id}&userName=${row.firstname}`,
        '_blank'
      )
    },
    // 页码操作
    getPageSizesVal(pageSizesVal) {
      this.pageSizesVal = pageSizesVal
      this.getCourseCapabilityStatPagination()
    },
    getCurPageVal(curPageVal) {
      this.currentPage = curPageVal
      this.getCourseCapabilityStatPagination()
    },
  },
}
</script>
<style lang="scss" scoped>
.ability-achieve {
  .radar-chart {
    height: 400px;
  }
  ::v-deep .el-table {
    thead {
      th.el-table__cell {
        background-color: #f5f7fa;
      }
      .header-transparent {
        th.el-table__cell {
          background-color: transparent !important;
        }
      }
    }
    .cell {
      color: #6c757d;
    }
    &.table-ability {
      tbody {
        .el-table__row:nth-child(2) {
          .el-table__cell {
            background-color: #f9f9f9;
          }
        }
      }
    }
  }
  .update-card {
    height: auto;
    display: inline-block;
    text-align: left;
    width: 100%;
    .card-title {
      margin-bottom: 7px;
      font-size: 16px;
      font-weight: bold;
      color: #343a40;
      line-height: 16px;
    }
    .update-time-tip-box {
      width: 100%;
    }
    .time-box {
      width: 100%;
      margin-top: 6px;
      padding: 13px 16px;
      background-color: rgba(243, 247, 249, 1);

      .mdi {
        font-size: 20px;
      }
    }
    .last-update-time {
      margin-top: 24px;
      border-radius: 4px;
      .icon-box {
        background: rgba(50, 148, 246, 0.25);
      }
    }
    .next-update-time {
      border-radius: 4px;
      .icon-box {
        background: rgba(68, 207, 156, 0.25);
      }
    }
    .icon-box {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 32px;
      height: 32px;
      border-radius: 4px;
    }
    .time-text {
      margin-left: 16px;
      line-height: 32px;
      white-space: nowrap;
    }
    .update-tips {
      font-size: 14px;
      color: #98a6ad;
      line-height: 21px;
    }
    .update-time {
      font-size: 14px;
      color: #6c757d;
      line-height: 14px;
    }
    .btn-group {
      width: 100%;
      margin-top: 24px;
      .operate-btn {
        width: 48%;
      }
    }
  }
}
</style>
